import { Component, OnInit } from '@angular/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {CommonDialogComponent} from 'src/app/common-dialog/common-dialog.component';
import { FieldWrapper } from '@ngx-formly/core';
import { get as _get, find as _find} from 'lodash-es';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged } from 'rxjs/operators';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { StudioIntegrationService } from "../../services/studio-integration/studio-integration.service";
import { testHtmlRegex } from '../../helpers/helpers';
import { filterDialogResult } from 'src/app/shared/helpers';

@Component({
  selector: 'app-accordion-wrapper',
  templateUrl: './accordion-wrapper.component.html',
  styleUrls: ['./accordion-wrapper.component.scss']
})
export class AccordionWrapperComponent extends FieldWrapper implements OnInit {
  mode: any;
  isHtml: boolean = false;
  
  constructor(private dialog: MatDialog,private route: ActivatedRoute,private studioIntegrationService: StudioIntegrationService,){
    super()
  }

  ngOnInit(): void {
    this.isHtml = testHtmlRegex(this.props.description);
    this.mode = _get(this.route, "snapshot.data.mode");
    if(this.mode === 'edit'){
      this.field.formControl.valueChanges.pipe(
        distinctUntilChanged()).
        subscribe((value) => {
          if(this.mode === 'edit' && _get(this.field.parent.props, 'agreedToReload') !== true && this.field.defaultValue != value){
            this.showReloadDialog()
          }
        })
    }else{
      this.studioIntegrationService.setAdvOptionsReloadAgreed = true;
    }
  }

  showReloadDialog(){
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: '',
        content: 'This action will force a reload of all previous tables',
        image: 'warning',
        buttons: [
          {
            'title': 'PROCEED',
            'meta': '',
            'type': 'change',
            'class': 'confirm-dialog-proceed'
          },
          {
            'title': 'CANCEL',
            'meta': '',
            'type': 'no-change',
            'class': 'confirm-dialog-later'
          }
        ]
      },
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
    });

    dialogRef.afterClosed().pipe(filterDialogResult<any>()).subscribe(result => {
      if(result?.type === 'no-change') {
       this.field.formControl.patchValue(this.field.defaultValue);
      } else{
        const advanceOptionProps = _get(this.field, "parent.props");
        advanceOptionProps.agreedToReload = true;
        this.studioIntegrationService.setAdvOptionsReloadAgreed = advanceOptionProps.agreedToReload;
      }
    })
  }

}
